<template>
  <div class="dialog" v-if="visible">
      <div class="close-ico" @click="hideDialog">
        <img :src="`${publicPath}/images/colse_icon.png`" alt="" />
      </div>
      <div class="dialog-body">
        <slot></slot>
      </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  props: {
      visible:{
        type:Boolean,
        default:false
      }
  },
  data() {
      return {
        publicPath: process.env.BASE_URL,
      };
  },
  methods: {
    hideDialog() {
      this.$emit('hideDialog')
      this.$emit('update:visible',false)
    }
  },
  watch: {
      
  },
  created() {
  },
  mounted() {},
};
</script>

<style scoped>
  .dialog {
    position: fixed;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: black;
  }
  .close-ico {
    width: 25px;
    height: 25px;
    top: 30px;
    right: 30px;
    cursor: pointer;
    position: absolute;
  }
  .close-ico img {
    width: 100%;
    height: 100%;
  }
   .dialog-body {
    width: 100%;
    height: 100%;
    padding-top: 60px;
    
  }
  
</style>
